import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';

export async function getAll() {
  const url = `${baseUrl}/auth/me/permissions`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
  };
  

  return axios.get<any>(url, {
    headers,
  });
}
